module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div'), _vm._v(" "), (!_vm.isIcon && _vm.allModuleId > 0) ? _c('b-button', {
    staticClass: "mb-1 mt-1",
    staticStyle: {
      "font-size": "0.675rem"
    },
    attrs: {
      "size": "xs"
    },
    on: {
      "click": function($event) {
        _vm.showPLInvExpModal(_vm.allModuleId)
      }
    }
  }, [_vm._v("Inv Exp Summary")]) : (_vm.isIcon && _vm.allModuleId > 0) ? _c('b-button', {
    directives: [{
      name: "b-tooltip",
      rawName: "v-b-tooltip.hover",
      modifiers: {
        "hover": true
      }
    }],
    staticClass: "mr-1 btn-action",
    attrs: {
      "size": "sm",
      "variant": "outline-secondary",
      "title": "Inv/Exp Summary"
    },
    on: {
      "click": function($event) {
        _vm.showPLInvExpModal(_vm.allModuleId)
      }
    }
  }, [_c('i', {
    class: _vm.iconClass || 'fa fa-list-alt'
  })]) : _vm._e(), _vm._v(" "), _c('b-modal', {
    ref: "PLInvExp-modal",
    attrs: {
      "no-close-on-esc": "",
      "no-close-on-backdrop": "",
      "size": "xl",
      "hide-footer": "",
      "title": _vm.Page_title
    }
  }, [(_vm.isLoading) ? _c('CustomLoader', {
    attrs: {
      "width": 70
    }
  }) : _vm._e(), _vm._v(" "), _c('b-row', [_c('b-col', {
    attrs: {
      "md": "12"
    }
  }, [(_vm.PLInvExpList.length > 0) ? _c('b-button', {
    staticClass: "pull-right mb-1",
    attrs: {
      "disabled": _vm.ExcelBtnName != 'Export As Excel' ? true : false,
      "size": "sm",
      "variant": "warning"
    },
    on: {
      "click": function($event) {
        _vm.getReports('getJobExpInvDetails', 'Export As Excel')
      }
    }
  }, [_vm._v("\n          " + _vm._s(_vm.ExcelBtnName) + "\n          "), (_vm.ExcelBtnName != 'Export As Excel') ? _c('b-spinner', {
    attrs: {
      "small": "",
      "label": "Small Spinner"
    }
  }) : _vm._e()], 1) : _vm._e(), _vm._v(" "), _c('b-button', {
    staticClass: "pull-right mb-1",
    attrs: {
      "disabled": _vm.ExcelBtnNameAll != 'All Split Export As Excel' ? true : false,
      "size": "sm",
      "variant": "warning"
    },
    on: {
      "click": function($event) {
        _vm.getReportsAll('getJobExpInvAllDetails', 'All Split Export As Excel')
      }
    }
  }, [_vm._v("\n          " + _vm._s(_vm.ExcelBtnNameAll) + "\n          "), (_vm.ExcelBtnNameAll != 'All Split Export As Excel') ? _c('b-spinner', {
    attrs: {
      "small": "",
      "label": "Small Spinner"
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('b-table', {
    attrs: {
      "show-empty": "",
      "stacked": "md",
      "items": _vm.PLInvExpList,
      "fields": _vm.PLInvExpfields,
      "per-page": _vm.perPage,
      "sort-by": _vm.sortBy,
      "sort-desc": _vm.sortDesc,
      "sort-direction": _vm.sortDirection
    },
    on: {
      "update:sortBy": function($event) {
        _vm.sortBy = $event
      },
      "update:sortDesc": function($event) {
        _vm.sortDesc = $event
      }
    },
    scopedSlots: _vm._u([{
      key: "SN",
      fn: function(row0) {
        return [_c('span', [_vm._v(_vm._s(row0.index + 1 + (_vm.currentPage - 1) * _vm.perPage))])]
      }
    }, {
      key: "inv_type",
      fn: function(row1) {
        return [_c('span', [_vm._v("Inv Type : " + _vm._s(row1.item.inv_type)), _c('br')]), _vm._v(" "), _c('span', [_vm._v("Inv Created : " + _vm._s(row1.item.inv_create_date)), _c('br')]), _vm._v(" "), _c('span', [_vm._v("Inv Updated : " + _vm._s(row1.item.inv_update_date))]), _vm._v(" "), (
          _vm.$sessionsStorage.get('designation') == 'Admin' &&
          _vm.$sessionsStorage.get('nameUser') == 'Bhavneesh'
        ) ? _c('div', {
          attrs: {
            "id": 'row' + row1.item.inv_id
          }
        }, [_c('md-switch', {
          staticClass: "md-primary",
          attrs: {
            "id": 'approval' + row1.item.inv_id,
            "name": "approval",
            "value": row1.item.inv_is_active == 0 ? true : false
          },
          on: {
            "change": function($event) {
              _vm.isRemoveItemSplit(row1.item)
            }
          }
        }, [_c('h6', [_c('br'), _vm._v(" "), _c('b-badge', {
          attrs: {
            "variant": row1.item.inv_is_active == 0 ? 'success' : 'danger'
          }
        }, [_vm._v(_vm._s(row1.item.inv_is_active == 0 ? "Remove" : "Pending"))])], 1)])], 1) : _vm._e()]
      }
    }])
  }), _vm._v(" "), (_vm.PLInvExpList.length > 0) ? _c('table', {
    staticClass: "table table-sm table-bordered mt-2"
  }, [_c('tbody', {
    staticStyle: {
      "background": "white"
    }
  }, [_c('tr', [_c('td', {
    staticStyle: {
      "text-align": "center",
      "color": "red"
    },
    attrs: {
      "colspan": "4"
    }
  }, [_c('b', [_vm._v("Total : ")])]), _vm._v(" "), _c('td', {
    staticStyle: {
      "text-align": "center",
      "color": "red"
    },
    attrs: {
      "colspan": "2"
    }
  }, [_c('b', [_vm._v("PL : " + _vm._s(_vm.PLAMT))])]), _vm._v(" "), _c('td', {
    staticStyle: {
      "text-align": "center",
      "color": "red"
    }
  }, [_c('b', [_vm._v("Exp : " + _vm._s(_vm.PLExpAMT))])]), _vm._v(" "), _c('td', {
    staticStyle: {
      "text-align": "center",
      "color": "red"
    }
  }, [_c('b', [_vm._v("Inv : " + _vm._s(_vm.PLInvAMT))])])])])]) : _vm._e(), _vm._v(" "), _c('div', [_c('h5', [_c('div', [_c('b-pagination', {
    attrs: {
      "limit": "25",
      "align": "center",
      "per-page": _vm.perPage,
      "total-rows": _vm.PLInvExpList.length
    },
    on: {
      "change": function($event) {
        _vm.onPageChange($event)
      }
    },
    model: {
      value: (_vm.currentPage),
      callback: function($$v) {
        _vm.currentPage = $$v
      },
      expression: "currentPage"
    }
  })], 1)])])], 1), _vm._v(" "), _c('b-col', {
    staticClass: "text-center",
    attrs: {
      "cols": "12"
    }
  }, [_c('b-button', {
    staticClass: "mt-3",
    attrs: {
      "variant": "outline-danger"
    },
    on: {
      "click": _vm.hidePLInvExpModal
    }
  }, [_vm._v("Close")])], 1)], 1)], 1), _vm._v(" "), _c('md-dialog-confirm', {
    ref: "addPop",
    attrs: {
      "md-content-html": _vm.alert.content,
      "md-ok-text": _vm.alert.ok
    },
    on: {
      "close": _vm.onClose
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5349f5a6","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/component/common/moduleBasedInvExpSummary.vue
// module id = 2630
// module chunks = 0